import React from 'react';
import { observer } from 'mobx-react';

import LandingModel from 'models/Landing/LandingModel';
import BasicItemModel from 'models/Landing/Elements/BasicItemModel';

import BaseEdit from '../../editor/BaseEdit';
import EditInput from '../../editor/EditInput';
import EditImage from '../../editor/EditImage';
import EditSelector from '../../editor/EditSelector';

import BasicElement from './BasicElement';
import OpenChatFlag from './OpenChatFlag';

type Props = {
  item: BasicItemModel,
  landing: LandingModel,
  index: number,
  isEditMode?: boolean
};

const EditBasic = ({ item, landing, index, isEditMode }: Props) => {
  const view = <BasicElement item={item} isEditMode={isEditMode} />;

  if (!isEditMode) {
    return view;
  }

  return (
    <BaseEdit
      index={index}
      landing={landing}
      item={item}
      view={view}
      editorComponent={
        <>
          <EditInput
            title="Заголовок"
            value={item.title}
            onChange={item.setTitle}
            errorMessage={item.errors.get('title')}
          />
          <EditInput
            title="Описание"
            value={item.description}
            onChange={item.setDescription}
            errorMessage={item.errors.get('description')}
          />
          <EditImage
            title="Изображение"
            value={item.imageUrl}
            onChange={value => item.uploadFile(value, landing.id)}
            onRemove={item.removeFile}
          />
          <EditInput
            onChange={item.getButton().setText}
            value={item.getButton().text}
            title="Текст на кнопке"
          />
          <OpenChatFlag
            onChange={item.getButton().setOpenChat}
            value={item.getButton().openChat}
          />
          <EditSelector
            title="Переход на блок"
            value={item.blockId}
            onChange={item.setBlockId}
            placeholder="Выберите блок"
          />
        </>
      }
    />
  );
};

EditBasic.defaultProps = {
  isEditMode: false
};

export default observer(EditBasic);
